module.exports = __webpack_public_path__ + "static/img/detail1.dea9791.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/detail1.png
// module id = eMsc
// module chunks = 0